import React from 'react';
import PropTypes from 'prop-types';
import { FormattedRelative, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import classNames from 'classnames';
import s from './HistoryAlarms.css';

class HistoryAlarmContainer extends React.Component {

  render() {
    const wrappedStyle = classNames(
      s.listBordered_item,
      s.u_flexNoWrap,
      s.u_linkPointer);
    return (
      <div className={wrappedStyle}>
        <div className={s.u_flexGrow1}>
          {this.props.children}
          <FormattedMessage {...this.props.message} />
        </div>
        {this.props.created ? (<span className={s.Alert_time}>
          <FormattedRelative value={new Date(this.props.created)} initialNow={new Date()}/>
        </span>) : null}
      </div>
    );
  }
}

HistoryAlarmContainer.propTypes = {
  created: PropTypes.string,
  children: PropTypes.node,
  message: PropTypes.object.isRequired,
};


export default withStyles(s)(HistoryAlarmContainer);



// WEBPACK FOOTER //
// ./src/components/HistoryAlarms/HistoryAlarmContainer.js